import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { QuillText, Paragraph as Title } from '@treams/treams-ui';

export default function Paragraph(props: {
	item: graphql.EvaluationParagraphItem;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();
	const { t } = useTranslation();

	return (
		<>
			<Title>{t('evaluation.form.paragraph.title')}</Title>
			<Box mt={3}>
				<QuillText value={localize(props.item.text).text} />
			</Box>
		</>
	);
}
